import type {Module} from "vuex";
import type {RouteLocationRaw} from "vue-router";
import type {RootState} from "@/store/types";

export interface Breadcrumb {
    text: string
    to?: RouteLocationRaw
    [key: string]: unknown
}

export interface BreadcrumbReplacePayload {
    find: string
    replace: Breadcrumb
}

export interface BreadcrumbsState {
    // array of breadcrumb objects, in the form of VueRouter
    // descriptors (see https://router.vuejs.org/api/#to)
    breadcrumbs: Breadcrumb[]
}

const breadcrumbs: Module<BreadcrumbsState, RootState> = {
    namespaced: true,
    state: {
        breadcrumbs: [],
    },
    getters: {
        items: (state): Breadcrumb[] => state.breadcrumbs
    },
    mutations: {
        set(state, breadcrumbs: Breadcrumb[]) {

            state.breadcrumbs = breadcrumbs;
        },
        push(state, breadcrumb: Breadcrumb) {

            state.breadcrumbs.push(breadcrumb)
        },
        pop(state) {

            state.breadcrumbs.pop();
        },
        replace(state, payload: BreadcrumbReplacePayload) {

            const index = state.breadcrumbs.findIndex((breadcrumb) => {

                return breadcrumb.text === payload.find;
            });

            if (index) {

                state.breadcrumbs.splice(index, 1, payload.replace);
            }
        },
        empty(state) {

            state.breadcrumbs = [];
        }
    }
}

export default breadcrumbs
